module.exports = VueI18n;


//////////////////
// WEBPACK FOOTER
// external "VueI18n"
// module id = 562
// module chunks = 62